// extracted by mini-css-extract-plugin
export default {"aboutMe":"ProfileAboutMe_aboutMe__fPiZB"};